import React from 'react';
import PropTypes from 'prop-types';
import SelectComponent from 'shared/components/SelectComponent';

const FrameSize = (props) => {
  const name = 'stencil_frame_size';
  const {
    label,
    required,
    tooltip,
    groupName,
    onChangeParameter,
    variants,
    parameters,
    errorMessage,
  } = props;

  const onChange = (e) => onChangeParameter(name, e.target.value);

  const options = { '': 'Select One' };

  if (variants && variants.length > 0) {
    variants.forEach((v) => {
      v.option_values.forEach((optionValue) => {
        const aditionalPrice = parseFloat(optionValue.aditional_price) || 0.0;

        if (optionValue.option_type_name === name) {
          options[optionValue.name] = `${optionValue.presentation}${aditionalPrice > 0 ? ` (+$${aditionalPrice})` : ''}`;
        }
      });
    });
  }

  const items = Object.keys(options).map((value) => ({ value, text: options[value] }));

  return (
    <SelectComponent
      label={label}
      required={required}
      name={name}
      onChange={onChange}
      options={items}
      tooltip={tooltip}
      selected={parameters[name] || ''}
      groupName={groupName}
      errorMessage={errorMessage} />
  );
};

FrameSize.propTypes = {
  label: PropTypes.string,
  required: PropTypes.bool,
  groupName: PropTypes.string,
  parameters: PropTypes.object.isRequired,
  onChangeParameter: PropTypes.func.isRequired,
  variants: PropTypes.arrayOf(PropTypes.object).isRequired,
  errorMessage: PropTypes.string,
  tooltip: PropTypes.string,
};

FrameSize.defaultProps = {
  groupName: 'price_modifiers',
  required: true,
  label: Spree.translations.parameters.stencil_frame_size	,
  tooltip: Spree.helpForParameters.stencil_frame_size	,
  errorMessage: '',
};

export default FrameSize;
